import {
  ABGLEICH_FELDER,
  type AbgleichFeld,
  type AbgleichZeile,
  type MitarbeiterFelder,
} from './entities/Mitarbeiterabgleich';

export function ermittleAbweichendeFelder(
  e2n: MitarbeiterFelder,
  datev: MitarbeiterFelder,
): AbgleichFeld[] {
  return ABGLEICH_FELDER.filter((feld) => e2n[feld] !== datev[feld]);
}

export function erstelleAbgleich(
  e2nMitarbeiter: MitarbeiterFelder[],
  datevMitarbeiter: MitarbeiterFelder[],
): { zeilen: AbgleichZeile[]; gesamt: number; uebereinstimmend: number } {
  const e2nByNr = new Map(e2nMitarbeiter.map((m) => [m.personalnr, m]));
  const datevByNr = new Map(datevMitarbeiter.map((m) => [m.personalnr, m]));

  const ids = [...new Set([...e2nByNr.keys(), ...datevByNr.keys()])].sort(
    (a, b) => a.localeCompare(b, 'de', { numeric: true }),
  );

  const zeilen = ids
    .map((id): AbgleichZeile => {
      const e2n = e2nByNr.get(id) ?? null;
      const datev = datevByNr.get(id) ?? null;

      return {
        id,
        e2n,
        datev,
        abweichendeFelder:
          e2n && datev ? ermittleAbweichendeFelder(e2n, datev) : [],
      };
    })
    .filter(
      (zeile) =>
        !zeile.e2n || !zeile.datev || zeile.abweichendeFelder.length > 0,
    );

  return {
    zeilen,
    gesamt: ids.length,
    uebereinstimmend: ids.length - zeilen.length,
  };
}
